import { useState, useEffect } from "react";

const getLocalValue = (key, initValue) => {
    //SSR Next.js
    if (typeof window === "undefined") return initValue;

    //if a value is already stored
    const raw = localStorage.getItem(key);
    if (raw === null) {
        // no value stored
    } else if (raw === "undefined") {
        localStorage.removeItem(key);
    } else {
        try {
            const localValue = JSON.parse(raw);
            if (localValue !== null && localValue !== undefined) return localValue;
        } catch (e) {
            localStorage.removeItem(key);
        }
    }

    // return result of a function 
    if (initValue instanceof Function) return initValue();

    return initValue;
}

const useLocalStorage = (key, initValue) => {

    const [value, setValue] = useState(() => {
        return getLocalValue(key, initValue);
    });

    useEffect(() => {
        localStorage.setItem(key, JSON.stringify(value));
    }, [key, value])

    return [value, setValue]
};

export default useLocalStorage